import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { GenericListComponent, HasAction, Actions, Page } from '../../shared-components/generic-list/generic-list.component';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { Talle } from '../talle/talle.model';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
import { EnvironmentProvider } from '../../core/browser-providers';
import { Environment } from '../../../environments/enviroment.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { MatPaginatorIntl } from '@angular/material';
import { SnackService } from '../../shared-services/snack.service';
import { TranslateService } from '../../core/translate.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { SecurityService } from '../../security/security.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Color } from './color.model';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';

interface Filters {
  description: string;
  page: number;
  size: number;
  sort: string;
  search?: string;
}

@Component({
  selector: 'app-color-list',
  templateUrl: './color-list.component.html',
  styleUrls: ['./color-list.component.scss']
})
export class ColorListComponent implements OnInit {

  constructor(@Inject(EnvironmentProvider) env: Environment,
  private route: ActivatedRoute,
  private backendService: BackendService,
  private paginatorsLabels: MatPaginatorIntl,
  private snackService: SnackService,
  private traslateService: TranslateService,
  public router: Router,
  protected updateEventService: UpdateEventService,
  private mediaService: MediaService,
  private http: Http,
  public securityService: SecurityService,
  private dialogService: DialogService,
  ) { }
  private filters: Filters = {
    description: undefined,
    page: 0,
    size: 10,
    sort: 'description'
  };

  columns = [
    { name: 'code',  label: 'Color' },
    { name: 'description',  label: 'Descripción' }
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(GenericListComponent)
  private genericListComponent: GenericListComponent;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  filtersActive = false;
  mostrarResumen = false;
  isLoading = false;
  pageSize = 25;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  itemsList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const coloresPromise = this.backendService.get(Color, Color.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const colores = await coloresPromise;
        return colores;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.filtersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Color[]>;

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.itemsList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshItemsList();
  }
  refreshItemsList() {
    this.itemsList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      description : undefined,
      sort: 'orden',
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshItemsList();
  }

  onSearch(searchText) {
    this.filters.search = 'description:' + searchText;
    this.refreshItemsList();
  }

  clearSearch() {
      this.searchComponent.searchBox.value = '';
      this.refreshItemsList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAdd() {
    this.router.navigate(['/colores/agregar']);
  }


  onEdit(color: Color) {
    this.router.navigate(['/colores/editar', color.id]);
  }


  async onDelete(color: Color) {

    this.dialogService.confirm('Eliminar color',
    '¿Está seguro que desea eliminar el color ' + color.description + '?')
    .then( res => {
      if (res) {
        this.deleteColor(res, color);
      }
    });

  }

  async deleteColor(res, color: Color) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Color.path + color.id);
        this.snackService.success('Colores eliminados correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshItemsList();
      }

    }

  }

  onFiltersChanged(event) {
    this.refreshItemsList();
  }

  removeChip(event) {
    this.refreshItemsList();
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/color/color-list.component.ts